var cushings = {
    lineGenerator: {
        init: function () {
            var strBannerClassName = '.d-banner';

            if ( jQuery( strBannerClassName ).length > 0 ) {
                jQuery( strBannerClassName ).each( function () {
                    var jPinLeft = jQuery( this ).find( '.js-pin-left' ),
                        jPinRight = jQuery( this ).find( '.js-pin-right' );

                    jQuery( 'body' ).append( cushings.lineGenerator.createLine( jPinLeft, jPinRight ) );
                } );
            }
        },
        getElementPosition: function ( element ) {
            var x = 0;
            var y = 0;
            var width = element.width();
            var height = element.height();

            x += element.offset().left;
            y += element.offset().top;

            return { top: y, left: x, width: width, height: height };
        },
        createLine: function ( element1, element2 ) {
            var elementPosition1 = cushings.lineGenerator.getElementPosition( element1 );
            var elementPosition2 = cushings.lineGenerator.getElementPosition( element2 );

            var x1 = elementPosition1.left + elementPosition1.width / 2;
            var y1 = elementPosition1.top + elementPosition1.height / 2;

            var x2 = elementPosition2.left + elementPosition2.width / 2;
            var y2 = elementPosition2.top + elementPosition1.height / 2;

            var length = Math.sqrt( ( ( x2 - x1 ) * ( x2 - x1 ) ) + ( ( y2 - y1 ) * ( y2 - y1 ) ) );

            var cx = ( ( x1 + x2 ) / 2 ) - ( length / 2 );
            var cy = ( ( y1 + y2 ) / 2 ) - ( 2 / 2 );

            var angle = Math.atan2( ( y1 - y2 ), ( x1 - x2 ) ) * ( 180 / Math.PI );

            return '<span class="connecting-lines" style="left:' + cx + 'px; top:' + cy + 'px; width:' + length + 'px; -webkit-transform:rotate(' + angle + 'deg); transform:rotate(' + angle + 'deg);"></span>';
        }
    }
};
